<!-- 举报列表 -->
<template>
  <div class="report">
    <div class="conent">
      <el-button
        type="primary"
        @click="jubaoClick"
        v-if="$cookies.get('auth_grade') == 80"
        >举报人员</el-button
      >
      <el-dialog title="添加举报人员" :visible.sync="dialogVisible" width="30%">
        <div style="margin-left: 40px">
          <el-form
            ref="form"
            :rules="rules"
            :model="sizeForm"
            label-width="100px"
          >
            <el-form-item label="精英手机号" prop="username">
              <el-input
                v-model="sizeForm.username"
                style="max-width: 450px"
              ></el-input>
            </el-form-item>
            <el-form-item label="举报内容" prop="report_content">
              <el-input
                type="textarea"
                v-model="sizeForm.report_content"
                maxlength="255"
                show-word-limit
                style="max-width: 450px"
                size="medium "
              ></el-input>
            </el-form-item>
            <el-form-item label="举报图片">
              <el-upload
                class="avatar-uploader"
                :action="url_Api + '/hr24_user/v1/upload_file/'"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  style="border: 1px dashed rgb(66, 62, 62)"
                ></i>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="okClick">确 定</el-button>
        </span>
      </el-dialog>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column
          prop="company_name"
          label="代理商公司名"
        ></el-table-column>
        <el-table-column prop="username" label="精英手机号"></el-table-column>
        <el-table-column
          prop="report_content"
          label="举报内容"
        ></el-table-column>
        <el-table-column prop label="举报照片">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.report_img.length > 0"
              style="width: 100px; height: 100px"
              :src="scope.row.report_img[0]"
              :preview-src-list="scope.row.report_img"
            ></el-image>
            <div v-else class="kong">暂无</div>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="举报时间"></el-table-column>
        <el-table-column
          prop="status"
          label="审核状态"
          v-if="$cookies.get('auth_grade') == 80"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 0 ? '' : danger" effect="dark">
              {{ scope.row.status === 0 ? "审核中" : "已下架" }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作"
          width="100"
          v-if="$cookies.get('auth_grade') == 100"
        >
          <template slot-scope="scope">
            <el-button
              @click="handleClick(scope.row)"
              type="danger"
              size="mini"
              :disabled="scope.row.status == 1"
              >下架</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="15"
          :total="total"
          :current-page="page + 1"
          hide-on-single-page
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { require, url_Api } from "@/utils/http_request.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      url_Api: "",
      tableData: [],
      total: 0,
      page: 0,
      dialogVisible: false,
      sizeForm: {},
      imageUrl: "",
      report_img: "",
      rules: {
        username: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        report_content: [
          { required: true, message: "请选择活动区域", trigger: "blur" },
        ],
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 创建确定按钮
    okClick() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }
        require("post", "/hr24_index_data/v1/report/", this.sizeForm).then(
          (res) => {
            if (!res.code) {
              this.$message(res.msg);
              this.dialogVisible = false;
              this.init();
            }
          }
        );
      });
    },
    pageChange(page) {
      this.page = page - 1;
      this.init();
    },
    init() {
      var obj = {
        page_num: this.page,
        agent_username: this.$cookies.get("agent_username")
          ? this.$cookies.get("agent_username")
          : "",
        auth_grade: this.$cookies.get("auth_grade"),
      };
      require("post", "/hr24_index_data/v1/report_elite_list/", obj).then(
        (res) => {
          if (!res.code) {
            console.log(res);
            this.total = res.data.report_count;
            this.tableData = res.data.report_data;
          }
        }
      );
    },
    handleClick(row) {
      console.log(row);
      this.$confirm("该操作将下架此人员, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          require("post", "/hr24_index_data/v1/hide_report_resume/", {
            agent_username: row.agent_username,
            username: row.username,
          }).then((res) => {
            if (!res.code) {
              require("post", "/hr24_resume/v1/resume_delete/", {
                phone: row.username,
              }).then((res) => {
                if (!res.code) {
                  this.$message({
                    type: "success",
                    message: res.msg,
                  });
                  this.init();
                }
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消下架",
          });
        });
    },
    jubaoClick() {
      this.dialogVisible = true;
      this.sizeForm = {
        agent_username: this.$cookies.get("agent_username"),
      };
      this.$refs.form.resetFields();
    },
    handleAvatarSuccess(res, file) {
      console.log(res);
      // 上传成功之后，得到res里面的file_id
      this.sizeForm.report_img = res.data.file_data.file_id;
      // 然后把你上传的图片给imageUrl
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.url_Api = url_Api;

    this.init();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  scoped>
/* //@import url(); 引入公共css类 */
.el-textarea .el-input--medium .el-textarea__inner {
  min-height: 75px;
}
.report {
  width: calc(100% - 190px);
  min-height: 80vh;
  background: #fff;
  margin-top: 68px;
  margin-left: 190px;
}
.conent {
  width: 90%;
  margin: auto;
  padding: 60px 0;
}
.page {
  padding: 20px 0;
  text-align: center;
}
.kong {
  width: 100px;
  line-height: 100px;
  text-align: center;
  background: #f5f5f5;
  color: #ccc;
}

.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/user_management/report_personnel.vue